import React from "react";
import { FaExclamationCircle } from "react-icons/fa";

const BasicTab = ({
  newTicket,
  setNewTicket,
  errors,
  setErrors,
  showDescription,
  setShowDescription,
  showGroup,
  setShowGroup,
  selectedAddons,
  handleRemoveAddon,
  toggleAddonMandatory,
  handleAddonQuantityChange,
  fetchAddons,
  setShowAddonsModal,
  handleVariantSelection,
}) => {
  console.log("BasicTab rendered with props:", {
    selectedAddonsLength: selectedAddons?.length || 0,
    selectedAddonsData: selectedAddons, // Fixed: Removed incorrect .selectedAddons
  })


console.log(  newTicket,"")
  return (
    <div className="">
      <div className="form-group mb-4 mt-4">
        <label>
          Ticket Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className={`form-control ${errors.name ? "is-invalid" : ""}`}
          placeholder="Enter ticket name"
          value={newTicket.name}
          onChange={(e) => {
            setNewTicket({ ...newTicket, name: e.target.value })
            if (e.target.value.trim()) {
              setErrors({ ...errors, name: "" })
            }
          }}
          required
        />
        {errors.name && (
          <div className="invalid-feedback d-block">
            <FaExclamationCircle className="me-1" />
            {errors.name}
          </div>
        )}
      </div>

<input
  type="text"
  className="form-control"
  placeholder="--"
  value={
    newTicket.qtyAvailable === "100000"
      ? "" 
      : newTicket.qtyAvailable || ""
  }
  onChange={(e) => {
    let value = e.target.value.trim()

   
    if (value === "∞" || value.toLowerCase() === "infinity") {
      value = "100000"
    }

  
    const numericValue = isNaN(Number(value)) ? value : Number(value)

    setNewTicket({
      ...newTicket,
      qtyAvailable: numericValue,
    })
  }}
/>
<small className="text-muted">
  Leave blank for unlimited tickets
</small>


      <div className="form-group mb-4">
        <div className={`tickets_dec_total_flex ${showDescription ? "description-active" : ""}`}>
          <div className="tick_des_div">
            <label>Ticket description</label>
            <div className="text-muted small mb-2">
              This information will be displayed along with your ticket in the registration page
            </div>
          </div>
          {!showDescription ? (
            <div className=" ">
              <button
                type="button"
                className="btn btn-outline-primary add-description-btn"
                onClick={() => setShowDescription(true)}
              >
                Add Description
              </button>
            </div>
          ) : (
            <div className={` ${showDescription ? "active-description" : ""}`}>
              <textarea
                className="form-control"
                rows={4}
                placeholder="Add description here..."
                value={newTicket.description}
                onChange={(e) =>
                  setNewTicket({
                    ...newTicket,
                    description: e.target.value,
                  })
                }
              />
              <div className="d-flex justify-content-end mt-2">
                <button
                  type="button"
                  className="btn btn btn-outline-danger"
                  onClick={() => {
                    setShowDescription(false)
                    setNewTicket({ ...newTicket, description: "" })
                  }}
                >
                  Remove
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="form-group mb-4">
        <div className={`tickets_dec_total_flex ${showGroup ? "description-active" : ""}`}>
          <div className="tick_des_div">
            <label>Ticket group</label>
            <div className="text-muted small mb-2">
              Ticket groups categorize different types of tickets based on factors like access, or activities,
              <br /> making it easier for attendees to choose the right one.
            </div>
          </div>
          {!showGroup ? (
            <div className=" ">
              <button
                type="button"
                className="btn btn-outline-primary add-group-btn"
                onClick={() => setShowGroup(true)}
              >
                Add to a Group
              </button>
            </div>
          ) : (
            <div className={`${showGroup ? "active_description_div" : ""}`}>
              <select
                className="form-select "
                value={newTicket.group}
                onChange={(e) =>
                  setNewTicket({
                    ...newTicket,
                    group: e.target.value,
                  })
                }
              >
                <option>Choose a Group</option>
                <option>VIP</option>
                <option>Standard</option>
                <option>Early Bird</option>
              </select>
              <div className=" mt-2">
                <button
                  type="button"
                  className="btn btn btn-outline-danger"
                  onClick={() => {
                    setShowGroup(false)
                    setNewTicket({ ...newTicket, group: "" })
                  }}
                >
                  Remove
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="form-group mb-4">
        <div className={`tickets_dec_total_flex ${showGroup ? "description-active" : ""}`}>
          <div className="tick_des_div">
            <label>Add-ons</label>
            <div className="text-muted small mb-3">
              Add-ons are additional features, services, or benefits that attendees can purchase alongside their <br />
              primary event tickets. (eg: VIP access, parking passes, merchandises, access to pre-event activities etc.)
            </div>
          </div>
          <div className=" ">
            <button
              type="button"
              className="btn btn-outline-primary add-addons-btn"
              onClick={() => {
                fetchAddons()
                setShowAddonsModal(true)
              }}
            >
              Add Add-ons
            </button>
          </div>
        </div>
      </div>
      {selectedAddons && Array.isArray(selectedAddons) && selectedAddons.length > 0 && (
        <div className="selected-addons mt-3">
          {selectedAddons.map((addon) => (
            <div key={addon.id} className="selected-addon bg-light p-3 rounded mb-3 border">
              <div className="d-flex justify-content-between align-items-start flex-wrap">
                <div className="flex-grow-1">
                  <div className="fw-semibold mb-1">{addon.name}</div>
                  <div className="text-muted small mb-1">
                    {addon.currency}{" "}
                    {addon.hasVariants && addon.selectedVariant ? addon.selectedVariant.price : addon.price}{" "}
                    {/* Use addon.price for non-variant add-ons */}
                    {addon.hasVariants && addon.selectedVariant && (
                      <span className="ms-1">({addon.selectedVariant.name})</span>
                    )}
                  </div>
                  {addon.description && <div className="small text-muted mb-2">{addon.description}</div>}

                  {/* Variant Dropdown */}
                  {addon.hasVariants && addon.variants.length > 1 && <></>}
                </div>

                {/* Right-side Controls */}
                <div className="d-flex flex-column align-items-end gap-2 ms-3">
                  <div className="d-flex align-items-center gap-1">
                    <label className="small text-muted mb-0">Qty:</label>
                    <select
                      className="form-select form-select-sm"
                      style={{ width: "70px" }}
                      value={addon.choose_quantity || 1}
                      onChange={(e) => {
                        const newQuantity = Number.parseInt(e.target.value)
                        console.log("[v0] Dropdown onChange triggered:", {
                          addonId: addon.id,
                          addonName: addon.name,
                          currentChooseQuantity: addon.choose_quantity,
                          newQuantity: newQuantity,
                        })
                        handleAddonQuantityChange(addon.id, newQuantity)
                      }}
                    >
                      {(() => {
                        // Get max quantity from linkedTickets or default to 10
                        const maxQty =
                          addon.linkedTickets && addon.linkedTickets.length > 0
                            ? Math.max(...addon.linkedTickets.map((lt) => lt.maxQuantity || 1))
                            : addon.quantity
                        return Array.from({ length: maxQty }, (_, i) => i + 1).map((num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        ))
                      })()}
                    </select>
                  </div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={addon.isMandatory === true}
                      onChange={() => toggleAddonMandatory(addon.id)}
                      id={`mandatory-switch-${addon.id}`}
                    />
                    <label className="form-check-label small" htmlFor={`mandatory-switch-${addon.id}`}>
                      Mandatory
                    </label>
                  </div>
                  <button className="btn btn-sm btn-link p-0 text-danger" onClick={() => handleRemoveAddon(addon.id)}>
                    <i className="fa fa-trash fs-6"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default BasicTab
